export const REGION_CONTENT = {
  in: {
    metaTitle: 'Shipmnts: Freight Forwarding Software & ERP for India',
    metaDescription:
      'Shipmnts is freight ERP software trusted by 6,000+ users across 180 freight forwarding companies in India. Manage operations, customs, finance, and compliance in one platform.',
    title: 'Freight Forwarding Software\nfor Indian Forwarders',
    subtitle:
      'Streamline your day-to-day operations, boost shipment profits, and delight your customers.',
    complianceTags: [
      'GST & TDS automation',
      'GSTR2B reconciliation',
      'E-invoicing included',
      'ICEGATE status tracking',
    ],
    hreflang: 'en-IN',
  },
  uae: {
    metaTitle: 'Shipmnts: Freight Forwarding Software for UAE & Gulf',
    metaDescription:
      'Shipmnts is freight ERP for UAE and Gulf freight forwarders. Manage air & ocean forwarding, documentation, multi-currency finance, and free zone operations in one platform.',
    title: 'Freight Forwarding Software\nfor UAE & Gulf Forwarders',
    subtitle:
      'Manage your full forwarding operation: inquiry to invoice: across Jebel Ali, DXB, and beyond. Trusted by forwarders across the Middle East.',
    complianceTags: [
      'Air & ocean freight',
      'Multi-currency invoicing',
      'Free zone operations',
      'Dubai & Jebel Ali routes',
    ],
    hreflang: 'en-AE',
  },
  us: {
    metaTitle: 'Shipmnts: Freight Forwarding Software for US NVOCCs & 3PLs',
    metaDescription:
      'Shipmnts freight ERP for US freight forwarders, NVOCCs, and 3PLs. Air & ocean freight management, one-click documentation, and integrated finance in one platform.',
    title: 'Freight Forwarding Software\nfor US NVOCCs & 3PLs',
    subtitle:
      'One platform for air & ocean forwarding, documentation, and finance. Trusted by freight forwarders across 15+ countries. AMS/ISF filing coming 2026.',
    complianceTags: [
      'Air & ocean FCL/LCL',
      'AWB & BL generation',
      'NVOCC operations',
      'AMS/ISF: coming 2026',
    ],
    hreflang: 'en-US',
  },
  global: {
    metaTitle: 'Shipmnts: Freight Forwarding Software & ERP',
    metaDescription:
      'Shipmnts is freight ERP software trusted by 6,000+ users across 180 freight forwarding companies in 15+ countries. Manage operations, finance, and compliance in one platform.',
    title: 'Freight Forwarding Software\nfor Global Operations',
    subtitle:
      'One platform for air & ocean forwarding, documentation, finance, and customer collaboration: trusted by 6,000+ users across 15+ countries.',
    complianceTags: [
      'Air & ocean forwarding',
      'One-click documentation',
      'Integrated finance',
      'Real-time analytics',
    ],
    hreflang: 'en',
  },
};
